import {css} from 'glamor'
import PropTypes from 'prop-types'
import {default as React} from 'react'
import Col from 'react-bootstrap/lib/Col'
import {default as Container, default as Grid} from 'react-bootstrap/lib/Grid'
import Modal from 'react-bootstrap/lib/Modal'
import Row from 'react-bootstrap/lib/Row'
import {colors, text} from '../../styles'
import {default as PrepButton} from '../button'
import close from '../../images/close.png'
import whiteHoodieExample from '../../images/white_hoodie_example.png'
import PromoEmailSignupForm from './promoEmailSignupForm'

const style = {
  noPaddingOrMargin: css({
    padding: 0,
    margin: 0
  }),
  section: {
    modalBody: css({
      padding: 0
    }),
    mobileModalBody: css({
      padding: 0,
      background: colors.gray95
    }),
    allContent: css({
      display: 'flex',
      padding: 0
    }),
    textContent: css({
      margin: '19px 25px',
      width: '100%'
    })
  },
  text: {
    bodyText: css(text.bodySmall, {
      paddingBottom: '7px'
    }),
    discountText: css({
      color: colors.primaryBG,
      marginTop: 0,
      marginBottom: 15
    })
  },
  closeIcon: css({
    height: '14px',
    width: '14px'
  })
}

const propTypes = {
  subscribeEmail: PropTypes.func.isRequired,
  hideModalCallback: PropTypes.func.isRequired
}

const DesktopContent = ({subscribeEmail, hideModalCallback}) => {
  return (
    <Modal.Body {...style.section.modalBody} className="hidden-xs">
      <Container fluid {...style.section.allContent} className="flex-nowrap">
        <img src={whiteHoodieExample} alt="white hoodie example image" />
        <Grid fluid {...style.section.textContent}>
          <Row>
            <Col className="text-right">
              <PrepButton kind="link" onClick={hideModalCallback}>
                <img src={close} alt="close" {...style.closeIcon} />
              </PrepButton>
            </Col>
          </Row>
          <Row>
            <h5>Sign up for email</h5>
          </Row>
          <Row>
            <p {...style.text.bodyText}>
              Be the first to hear about new products, promotions and deals up
              to:{' '}
            </p>
          </Row>
          <Row>
            <h2 {...style.text.discountText}> 30% OFF</h2>
          </Row>
          <Row>
            <Col>
              <PromoEmailSignupForm
                subscribeEmail={subscribeEmail}
                hideModalCallback={hideModalCallback}
              />
            </Col>
          </Row>
        </Grid>
      </Container>
    </Modal.Body>
  )
}

DesktopContent.propTypes = propTypes

const MobileContent = ({subscribeEmail, hideModalCallback}) => {
  return (
    <Modal.Body {...style.section.mobileModalBody} className="visible-xs">
      <Container fluid {...style.section.allContent} className="flex-nowrap">
        <Grid fluid {...style.section.textContent}>
          <Row>
            <Col xs={10} {...style.noPaddingOrMargin}>
              <h5 {...style.noPaddingOrMargin}>
                <span>Sign up & save up to: </span>
                <span {...style.text.discountText}>30% off</span>
              </h5>
            </Col>
            <Col xs={2} {...style.noPaddingOrMargin} className="text-right">
              <PrepButton kind="link" onClick={hideModalCallback}>
                <img src={close} alt="close" {...style.closeIcon} />
              </PrepButton>
            </Col>
          </Row>
          <Row>
            <p {...style.text.bodyText}>
              Be the first to hear about new products & deals.
            </p>
          </Row>
          <Row>
            <Col>
              <PromoEmailSignupForm
                subscribeEmail={subscribeEmail}
                hideModalCallback={hideModalCallback}
              />
            </Col>
          </Row>
        </Grid>
      </Container>
    </Modal.Body>
  )
}

MobileContent.propTypes = propTypes

const ModalContent = props => {
  return (
    <>
      <MobileContent {...props} />
      <DesktopContent {...props} />
    </>
  )
}

export default ModalContent
